import { render, staticRenderFns } from "./Otp.vue?vue&type=template&id=e5d693e6&scoped=true"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"
import style0 from "./Otp.vue?vue&type=style&index=0&id=e5d693e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d693e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5d693e6')) {
      api.createRecord('e5d693e6', component.options)
    } else {
      api.reload('e5d693e6', component.options)
    }
    module.hot.accept("./Otp.vue?vue&type=template&id=e5d693e6&scoped=true", function () {
      api.rerender('e5d693e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/otp/Otp.vue"
export default component.exports